<div class="course-area-start" id="cursos">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="title-between-area">
          <div class="title-area-left-style">
            <div class="pre-title">
              <img src="assets/images/banner/bulb.png" alt="icon" />
              <span>Cursos</span>
            </div>
            <h2 class="title">O que você deseja estudar?</h2>
            <p class="post-title">
              A escolha da sua carreira é o primeiro passo para o seu futuro!
            </p>
          </div>
          <div class="button-group filters-button-group">
            <button
              class="button"
              [ngClass]="{ 'is-checked': filtroSelecionado === 'graduacao' }"
              (click)="aplicarFiltro('graduacao')"
            >
              Graduação
            </button>
            <button
              class="button"
              [ngClass]="{
                'is-checked': filtroSelecionado === 'pos-graduacao'
              }"
              (click)="aplicarFiltro('pos-graduacao')"
            >
              Pós-Graduação
            </button>
            <button
              class="button"
              [ngClass]="{ 'is-checked': filtroSelecionado === 'mba' }"
              (click)="aplicarFiltro('mba')"
            >
              MBA
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="portfolio_wrap">
      <div
        class="filter row g-5 mt--20 portfolio-feed personal align-items-start"
      >
        <div
          class="flash grid-item-p element-item transition col-xl-3 col-lg-4 col-md-6 col-sm-6"
          *ngFor="let curso of cursosPaginados"
          [ngClass]="curso.filterClass"
          data-category="transition"
        >
          <div class="rts-single-course">
            <a [href]="curso.link" class="thumbnail">
              <img [src]="curso.imagem" alt="course" />
            </a>
            <div class="tags-area-wrapper">
              <div class="single-tag" *ngFor="let tag of curso.tags">
                <span>{{ tag }}</span>
              </div>
            </div>
            <div class="lesson-studente"></div>
            <a>
              <h5 class="title limit-lines">
                {{ curso.nome }}
              </h5>
            </a>

            <a
              data-bs-toggle="modal"
              data-bs-target="#modal-inscricao"
              (click)="selecionarCurso(curso)"
              class="rts-btn btn-primary with-arrow text-center"
              [ngStyle]="{
                display: 'block',
                padding: '6px 20px',
                'max-width': 'none',
                width: '100%'
              }"
              >Inscreva-se <i class="fa-solid fa-arrow-right"></i
            ></a>
            <a
              [routerLink]="['/cursos', curso.slug]"
              class="d-block text-center text-primary mt-4"
              >Saiba mais</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row mb--80">
      <div class="col-lg-12">
        <div class="rts-pagination-area-2">
          <ul>
            <li (click)="paginaAnterior()" [class.disabled]="paginaAtual === 1">
              <i class="fa-solid fa-chevron-left"></i>
            </li>

            <li
              *ngFor="let pagina of getPaginasParaExibir()"
              [class.active]="paginaAtual === pagina"
              (click)="mudarPagina(pagina)"
            >
              {{ pagina }}
            </li>

            <li
              (click)="proximaPagina()"
              [class.disabled]="paginaAtual === totalPaginas"
            >
              <i class="fa-solid fa-chevron-right"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Pré-Inscrição -->
<div
  class="modal inscricao-popup-modal fade"
  id="modal-inscricao"
  tabindex="-1"
  aria-labelledby="modalInscricaoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalInscricaoLabel">Inscreva-se</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" class="login-form">
          <input type="text" placeholder="Nome" formControlName="name" />
          <input
            type="email"
            placeholder="E-mail"
            formControlName="email"
            (input)="onEmailInput($event)"
          />
          <input
            type="text"
            maxlength="20"
            placeholder="Celular"
            formControlName="mobile"
            placeholder="DDD + Celular"
            mask="(00) 00000-0000"
          />

          <button type="submit" class="rts-btn btn-primary">Continuar</button>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Modal de Pré-Inscrição -->